import { LitElement, html } from "lit";

import api from "../../api/index.js";
import tableStyles from "../../styles/tables.js";
import sharedStyles from "../../styles/shared.js";
import inputStyles from "../../styles/input.js";

export default class AMLInvestorCountryListView extends LitElement {
	static get properties() {
		return {
			rows: {
				type: Array,
			},
		};
	}

	render() {
		return html`
      ${sharedStyles}
      ${tableStyles}
      ${inputStyles}
      <style>
      :host {
        display: block;
        margin: 24px auto;
        max-width: 1200px;
      }
      </style>
      <div class="card">
        <div class="card-header">
          <h2>Investor countries ${this.dateStr}</h2>
        </div>
        <table>
          <thead>
            <tr>
            <th>Cty</th>
             <th>Name</th>
             <th>Addresses</th>
             <th>Citizen 1</th>
             <th>Citizen 2</th>
             <th>Risk</th>
            </tr>
          </thead>
          <tbody>
            ${this.rows.map(
							(row) => html`
              <tr>
                <td>${row.country}</td>
                <td>${row.name}</td>
                <td>${row.address_count}</td>
                <td>${row.citizen1_count}</td>
                <td>${row.citizen2_count}</td>
                <td>${row.sanction}</td>
              </tr>
            `,
						)}
          </tbody>
        </table>
      </div>
    `;
	}

	constructor() {
		super();
		this.rows = [];
		this.dateStr = "";
	}

	async connectedCallback() {
		super.connectedCallback();
		const dt = new Date();
		this.dateStr = dt.toLocaleString();
		this.rows = await api.get("/aml/investorcountries");
	}
}

customElements.define(
	"aml-investor-country-list-view",
	AMLInvestorCountryListView,
);
